'use strict';

export const findElem = <T extends HTMLElement>(idOrClassName : string, context : Document | T = document) : T | HTMLElement | null => context.querySelector(idOrClassName),
    findElems = <T extends HTMLElement>(idOrClassName : string, context : Document | T = document) : NodeListOf<T> | NodeListOf<HTMLElement> | null => context.querySelectorAll(idOrClassName),
    arrayFrom = <T>(pseudoArray : ArrayLike<T> | null) : T[] | [] => pseudoArray ? Array.from(pseudoArray) : [],
    addClass = <T extends HTMLElement>(className : string, domElement : T | null) : void | null => domElement ? domElement.classList.add(className) : null,
    removeClass = <T extends HTMLElement>(className : string, domElement : T | null) : void | null => domElement ? domElement.classList.remove(className) : null,
    isContainsClass = <T extends HTMLElement>(className : string, domElement : T | null) : boolean => domElement ? domElement.classList.contains(className) : false,
    toggleClass = <T extends HTMLElement>(className : string, domElement : T | null) : boolean | null => domElement ? domElement.classList.toggle(className) : null;

export const handleValidateForms = () : void => {
    const formsEls = <HTMLFormElement[] | []>arrayFrom(findElems('.needs-validation'));

    formsEls.forEach((form : HTMLFormElement) : void => {
        form.addEventListener('submit', (e : SubmitEvent) : void => {
            if (!form.checkValidity()) {
                e.preventDefault()
                e.stopPropagation()
            }

            addClass('was-validated', form);
        }, false);
    })
};

export async function fetchFunc(url : string, data : object | FormData, method : string = 'POST', contentType : string = 'application/json;charset=utf-8') : Promise<any> {
    type TypeHeaders = {
        "X-CSRF-TOKEN" : string,
        "X-Requested-With" : string,
        contentType? : string,
    };

    const metaCsrfElem = findElem('meta[name=csrf-token]'),
        csrf_token = metaCsrfElem instanceof HTMLMetaElement ? metaCsrfElem.content : '';

    const headers : TypeHeaders = {
        'X-CSRF-TOKEN': csrf_token,
        'X-Requested-With': 'XMLHttpRequest',
    };

    type TypeOptions = {
        method? : string,
        headers : TypeHeaders,
        body? : FormData | string
    };

    let options : TypeOptions = {
        method,
        headers
    };

    if (method.toUpperCase() === 'GET') {
        options = {headers};
    } else if (!(data instanceof FormData)) {
        options.headers.contentType = contentType;
        options.body = JSON.stringify(data);
    } else if (data instanceof FormData) {
        options.body = data;
    }

    return (await fetch(url, options)).json();
}

export const isLastLoop = (loopIndex : number, props : any) : boolean => {
    if (props == 'undefined' || !props) {
        return false;
    }

    return loopIndex == Object.keys(props).length - 1;
};
